define('gigaset_recurring/classes/provider/billwerk/steps/address',[
	"jquery",
	"lodash",
	"./address/_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"text!shoptheme/templates/customer/address.html",
	"jquery-serialize-object"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger,
	AddressHtml
) {

	var addressTemplate = null

	function AddressStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring.address");
		this.rootElement = $('#step-address');
	}

	AddressStep.prototype = _.create(new AbstractStep, {
		constructor: AddressStep,

		currentAddressFormKey: "remote",

		validate: function() {
			var module = this.getData("module"),
				url = _.get(module, "billwerk.validateAddressUrl"),
				dfd;

			if (this.currentAddressSource === AbstractStep.ADDRESS_SOURCE_DIFFERENT) {
				// if (this.currentAddressCreate) {
				if (!url) {
					this.logger.error("Address validation URL is missing", module);
					throw new Error("Address validation URL is missing");
				}

				this.proceedButton.button("loading");

				dfd = $.Deferred();

				$.post(url, this.collectFormData())
					.always(_.bind(function() {
						this.proceedButton.button("reset");
					}, this))
					.done(_.bind(function() {
						dfd.resolve();
					}, this))
					.fail(_.bind(function(xhr) {
						var error = xhr.responseJSON;
						var message = module.translate("Address validation failed");

						if ("errors" in error) {
							if (_.isArray(error.errors)) {
								message = error.errors.join('<br/>');
							} else if (_.isString(error.errors)) {
								message = error.errors;
							}
						}

						var url = _.get(error, 'url');
						if (url) {
							this.getData("module").once("modal.close", function() {
								window.location.href = url;
							});
						}

						this.logger.error("Address validation failed", error);
						var e = new Error("Address validation failed");
						e.errorCode = ['AddressValidationError'];
						e.errorMessage = message;
						module.handleError(e, message);
						dfd.reject();
					}, this));

				return dfd.promise();
				// }
			}

			if (this.currentAddressSource === AbstractStep.ADDRESS_SOURCE_CURRENT) {
				return '' !== _.trim(this.address.current);
			} else if (this.currentAddressSource === AbstractStep.ADDRESS_SOURCE_DIFFERENT) {
				if (this.currentAddressCreate) {
					var valid = this.formValidate.validate();

					if (!valid) {
						this.emit("layout");
					}

					return valid;
				}

				return '' !== _.trim(this.address.different);
			}

			return false;
		}
	});

	return AddressStep;

});
